// extracted by mini-css-extract-plugin
module.exports = {"main":"LayoutContainer_main__1yeF3","main-contents":"LayoutContainer_main-contents__QPsDA"};